import React, { Component } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Chart, Series, Axis, Bar } from 'react-charts';

import $ from 'jquery';
import Ajax from '../ajax/Ajax';

function sortStats(stats) {
	return function(a, b) {
		return  b.y - a.y;
	};
}

class Characters extends Component {
	
	constructor(props) {
		super(props);
		this.state = {characters: {}, sorted: false, stats: false};
		this.addCharacter = this.addCharacter.bind(this);
		this.updateCharacter = this.updateCharacter.bind(this);
		this.update = this.update.bind(this);
		this.sortCharacters = this.sortCharacters.bind(this);
		this.computeStats = this.computeStats.bind(this);
	}
	
	computeStats(characters) {
		var classesAlive = { Guerrier: 0, Moine: 0, Rôdeur: 0, Roublard: 0, Sorcier: 0, Ensorceleur: 0, Magicien: 0, Artificier: 0, Paladin: 0, Clerc: 0, Druide: 0, Barde: 0, Barbare: 0 };
		var classesDead = { Guerrier: 0, Moine: 0, Rôdeur: 0, Roublard: 0, Sorcier: 0, Ensorceleur: 0, Magicien: 0, Artificier: 0, Paladin: 0, Clerc: 0, Druide: 0, Barde: 0, Barbare: 0 };
		var racesAlive = {};
		var racesDead = {};
		var gendersAlive = {};
		var gendersDead = {};
		var states = {};
		var haveCharacters = false;
		
		
		for (var key in characters) {
			console.log(key);
			if (characters.hasOwnProperty(key)) {
				var c = characters[key];
				if (c.state === "") {
					continue;
				}
				haveCharacters = true;
				var c = characters[key];
				var cClass = c.classes;
				if (cClass.includes("-")) {
					
					var split = c.classes.split(" "); //"Multiclassé";
					if (split[1] >= split[4])
						cClass = split[0];
					else
						cClass = split[3];
				}
					
				var race = c.race;
				var gender = c.sex;
				var state = c.state;
				
				if (state === "Vivant") {
					if (classesAlive.hasOwnProperty(cClass)) {
						var count = classesAlive[cClass];
						classesAlive[cClass] = ++count;
					} else {
						classesAlive[cClass] = 1;
					}
					
					if (racesAlive.hasOwnProperty(race)) {
						var count = racesAlive[race];
						racesAlive[race] = ++count;
					} else {
						racesAlive[race] = 1;
					}
					
					if (gendersAlive.hasOwnProperty(gender)) {
						var count = gendersAlive[gender];
						gendersAlive[gender] = ++count;
					} else {
						gendersAlive[gender] = 1;
					}
				} else {
					if (classesDead.hasOwnProperty(cClass)) {
						var count = classesDead[cClass];
						classesDead[cClass] = ++count;
					} else {
						classesDead[cClass] = 1;
					}
					
					if (racesDead.hasOwnProperty(race)) {
						var count = racesDead[race];
						racesDead[race] = ++count;
					} else {
						racesDead[race] = 1;
					}
					
					if (gendersDead.hasOwnProperty(gender)) {
						var count = gendersDead[gender];
						gendersDead[gender] = ++count;
					} else {
						gendersDead[gender] = 1;
					}
				}
				
				if (states.hasOwnProperty(state)) {
					var count = states[state];
					states[state] = ++count;
				} else {
					states[state] = 1;
				}
				
				var fClassesAlive = [];
				for (var k in classesAlive ) {
					if (classesAlive .hasOwnProperty(k)) {
						var count = classesAlive [k];
						fClassesAlive .push({x: k, y: count});
					}
				}
				
				var fRacesAlive  = [];
				for (var k in racesAlive ) {
					if (racesAlive .hasOwnProperty(k)) {
						var count = racesAlive [k];
						fRacesAlive .push({x: k, y: count});
					}
				}
				
				var fGendersAlive  = [];
				for (var k in gendersAlive ) {
					if (gendersAlive .hasOwnProperty(k)) {
						var count = gendersAlive[k];
						fGendersAlive .push({x: k, y: count});
					}
				}
				
				var fClassesDead = [];
				for (var k in classesDead) {
					if (classesDead.hasOwnProperty(k)) {
						var count = classesDead[k];
						fClassesDead.push({x: k, y: count});
					}
				}
				
				var fRacesDead = [];
				for (var k in racesDead) {
					if (racesDead.hasOwnProperty(k)) {
						var count = racesDead[k];
						fRacesDead.push({x: k, y: count});
					}
				}
				
				var fGendersDead = [];
				for (var k in gendersDead) {
					if (gendersDead.hasOwnProperty(k)) {
						var count = gendersDead[k];
						fGendersDead.push({x: k, y: count});
					}
				}
				
				var fStates = [];
				for (var k in states) {
					if (states.hasOwnProperty(k)) {
						var count = states[k];
						fStates.push({x: k, y: count});
					}
				}
				
			}
		}
		if (haveCharacters) {
			var stats = {
				classes: [{label: "Vivant", data: fClassesAlive.sort(sortStats(fClassesAlive))}, {label: "Mort", data: fClassesDead.sort(sortStats(fClassesAlive))}], 
				races: [{label: "Vivant", data: fRacesAlive.sort(sortStats(fRacesAlive))}, {label: "Mort", data: fRacesDead.sort(sortStats(fRacesAlive))}], 
				genders: [{label: "Vivant", data: fGendersAlive.sort(sortStats(fGendersAlive))}, {label: "Mort", data: fGendersDead.sort(sortStats(fGendersAlive))}], 
				states: [{label: "Status", data: fStates}]};
			this.setState({stats: stats});
		}		
	}
	
	componentWillMount() {
		var obj = this;
		Ajax.getCharacters().then(function(characters) {
			var keysSorted = Object.keys(characters).sort(
				function(a, b) {
					return (characters[a]["player"].toLowerCase() < characters[b]["player"].toLowerCase() ? -1 : 1);
				}
			);
			obj.setState({characters: characters, sorted: keysSorted});
			obj.computeStats(characters);
		});
	}
	
	sortCharacters(field) {
		var obj = this;
		return function(event) {
			var list = obj.state.characters;
			var keysSorted = Object.keys(list).sort(
				function(a, b) {
					if (field === "level") {
						return (Number(list[a][field]) < Number(list[b][field]) ? -1 : 1);	
					} else {
						return (list[a][field].toLowerCase() < list[b][field].toLowerCase() ? -1 : 1);	
					}					
				}
			);
			obj.setState({sorted: keysSorted});
		}
	}
	
	update(characters) {
		var obj = this;
		Ajax.postCharacters(characters).then(function () {
			obj.setState({characters: characters});
			obj.computeStats(characters);
		});		
	}
	
	addCharacter(event) {
		var obj = this;
		Ajax.getCharacters().then(function (characters) {
			var id = (Date.now().toString(36) + Math.random().toString(36).substr(2, 5)).toUpperCase();
			
			var character = {
				player: "",
				characterName: "",			
				race: "",
				sex: "",
				level: "",
				classes: "",
				state: ""
			}
			characters[id] = character;	
			var keysSorted = Object.keys(characters).sort(
					function(a, b) {
						return (characters[a]["player"].toLowerCase() < characters[b]["player"].toLowerCase() ? -1 : 1);
					}
				);

			obj.setState({characters: characters, sorted: keysSorted});
			obj.update(characters);
		});		
	}
	
	updateCharacter(id) {
		var obj = this;
		
		return function(event) {
			Ajax.getCharacters().then(function (characters) {
				var el = $("#" + id);
				var player = $(".PlayerName", el).first()[0].innerHTML;
				var characterName = $(".CharacterName", el).first()[0].innerHTML;
				var race = $(".CharacterRace", el).first()[0].innerHTML;
				var sex = $(".CharacterSex", el).first()[0].innerHTML;
				var level = $(".CharacterLevel", el).first()[0].innerHTML;
				var classes = $(".CharacterClass", el).first()[0].innerHTML;
				var state = $(".CharacterStatus", el).first()[0].innerHTML;
				var character = {
					player: player,
					characterName: characterName,			
					race: race,
					sex: sex,
					level: level,
					classes: classes,
					state: state
				}
				
				characters[id] = character;
				obj.setState({characters: characters});
				obj.update(characters);
			});
		};
	}
	
	render() {
		var characters = this.state.characters;
		var sorted = this.state.sorted;
		var stats = this.state.stats;
		var obj = this;
		console.log(stats);
		
		return (
		<div className="Characters">			
			
			<div className="CharactersList">
				<div className="CharactersListHeaders">					
					<div className="CharactersListHeader PlayerName" onClick={this.sortCharacters("player")}>Joueur</div>
					<div className="CharactersListHeader CharacterName" onClick={this.sortCharacters("characterName")}>Perso</div>
					<div className="CharactersListHeader CharacterRace" onClick={this.sortCharacters("race")}>Race</div>
					<div className="CharactersListHeader CharacterSex" onClick={this.sortCharacters("sex")}>Sexe</div>
					<div className="CharactersListHeader CharacterLevel" onClick={this.sortCharacters("level")}>Niveau</div>
					<div className="CharactersListHeader CharacterClass" onClick={this.sortCharacters("classes")}>Classe(s)</div>
					<div className="CharactersListHeader CharacterStatus" onClick={this.sortCharacters("state")}>Statut</div>
				</div>
				<div className="AddSymbol" onClick={this.addCharacter}><FontAwesomeIcon icon="user-plus"/></div>
				
				{characters && sorted ? 
				
				sorted.map(function(key, idx) {
					var character = characters[key];
					return (
					<div id={key} key={idx} className="Character">
						<div className="CharacterField PlayerName single-line" contentEditable="true" onBlur={obj.updateCharacter(key)} dangerouslySetInnerHTML={{__html: character.player}}></div>
						<div className="CharacterField CharacterName single-line" contentEditable="true" onBlur={obj.updateCharacter(key)} dangerouslySetInnerHTML={{__html: character.characterName}}></div>
						<div className="CharacterField CharacterRace single-line" contentEditable="true" onBlur={obj.updateCharacter(key)} dangerouslySetInnerHTML={{__html: character.race}}></div>
						<div className="CharacterField CharacterSex single-line" contentEditable="true" onBlur={obj.updateCharacter(key)} dangerouslySetInnerHTML={{__html: character.sex}}></div>
						<div className="CharacterField CharacterLevel single-line" contentEditable="true" onBlur={obj.updateCharacter(key)} dangerouslySetInnerHTML={{__html: character.level}}></div>
						<div className="CharacterField CharacterClass single-line" contentEditable="true" onBlur={obj.updateCharacter(key)} dangerouslySetInnerHTML={{__html: character.classes}}></div>
						<div className={"CharacterField CharacterStatus single-line " + character.state }  contentEditable="true" onBlur={obj.updateCharacter(key)} dangerouslySetInnerHTML={{__html: character.state}}></div>
					</div>
					)
				}): null
				}
				
			</div>
			<div className="Charts">				
				<div className="Chart">
					<Chart data={stats.classes} dark>
						<Axis primary type="ordinal" />
						<Axis type="linear" min={0} max={0} stacked />
						<Series type={Bar}
								getStyles={series => ({
									  color: series.index === 0 ? "darkgreen" : "black"
									})}					
						/>
					</Chart>
				</div>
				<div className="Chart">
					<Chart data={stats.races} dark>
						<Axis primary type="ordinal" />
						<Axis type="linear" min={0} max={0} stacked />
						<Series type={Bar}
								getStyles={series => ({
									  color: series.index === 0 ? "darkgreen" : "black"
									})}					
						/>
					</Chart>
				</div>
				
				<div className="Chart">
					<Chart data={stats.genders} dark>
						<Axis primary type="ordinal" />
						<Axis type="linear" min={0} max={0} stacked />
						<Series type={Bar}
								getStyles={series => ({
									  
									  color: series.index === 0 ? "darkgreen" : "black"
									})}												
						/>
					</Chart>
				</div>						
				<div className="Chart">
					<Chart data={stats.states} dark>
						<Axis primary type="ordinal" />
						<Axis type="linear" min={0} max={0} />
						<Series type={Bar}
								getDatumStyles={d => ({
									   color: d.index === 0 ? "darkgreen" : "black"
									})}							/>
					</Chart>
				</div>						
			</div>
		</div>
		);
	}
}

export default Characters;



// WEBPACK FOOTER //
// ./src/components/Characters.js